// extracted by mini-css-extract-plugin
export var bgDark = "styles-module--bgDark--yHcgf";
export var btnLogin = "styles-module--btnLogin--BmMaK";
export var dropdownMenu = "styles-module--dropdownMenu--f1z72";
export var logo = "styles-module--logo--1Uh6V";
export var logo2 = "styles-module--logo2--8vcSI";
export var logoWord = "styles-module--logoWord--+0NHh";
export var navbarCollapse = "styles-module--navbarCollapse--g5HrZ";
export var navbarCollapseContractor = "styles-module--navbarCollapseContractor--gIk0O";
export var navbarContentLeft = "styles-module--navbarContentLeft--7sCrr";
export var navbarDivider = "styles-module--navbarDivider--mRijI";
export var other = "styles-module--other--7a0-G";